/*
 * BUDCADE - Event planner script (sections/bc-event-builder.liquid)
 * Docs: docs/event-builder.md
 *
 * The plan is the Shopify cart. Each planner line carries hidden
 * properties so we know which Event item it is (_bc = item handle);
 * stations that share one variant stay separate lines because their
 * properties differ. Event details are cart attributes, so they reach
 * the order as "Additional details".
 *
 * Rules (all set per item in Shopify admin, none hard-coded here):
 *  - max: most of one item per plan
 *  - pick: a package asks which stations go in it
 *  - needsStation: extras like Extra hour need something hosted first
 *  - free + freeWith: swap to the $0 variant once the plan has that many stations
 *  - deposit: packages can be held with 50% instead of paid in full
 *  - kind "fee": added to every plan that has something hosted in it
 *  - kind "minimum": the event part of a plan is topped up to its amount with
 *    a $1 line, so everything in the plan counts toward the minimum
 *  - travelRate: the kind "minimum" item with a rate is the travel line. The
 *    event ZIP sets its distance from travelFrom, and it charges $rate per 100
 *    road miles once the trip is over travelFree. Past travelMax
 *    the plan goes to a call instead of checkout
 *  - off + code: a $0 item that takes money off with a Shopify discount code.
 *    It needs a hosted line whose tags are all among its own tags, and the
 *    minimum is counted before it comes off
 */
(function () {
  var root = document.querySelector('[data-bc-plan]');
  if (!root) return;

  var ITEMS = JSON.parse(root.querySelector('[data-plan-items]').textContent);
  var BY = {};
  var BY_VARIANT = {};
  ITEMS.forEach(function (it) {
    BY[it.handle] = it;
    [it.variant, it.deposit, it.free].forEach(function (v) {
      if (!v) return;
      // A variant shared by several items (one price for every station)
      // can't name the item on its own; only unique ones are mapped.
      BY_VARIANT[v] = BY_VARIANT[v] === undefined ? it.handle : null;
    });
  });

  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var cart = { items: [], attributes: {} };
  var busy = false;
  var HOSTED = { package: 1, station: 1, item: 1 };
  // Lessons and consulting ("service") stand on their own: no event date,
  // no event minimum. Everything else is part of an event.
  var NOT_EVENT = { service: 1, minimum: 1 };

  // When the rest of a 50% hold is due: event day, or handover for a service.
  function balanceDue(it) { return it.kind === 'service' ? 'at handover' : 'the day of your event'; }
  function depositNote(it) { return '50% now, the rest ' + balanceDue(it); }

  // Road miles run about 1.2x the straight line, so this is an estimate, and
  // the plan calls it one.
  var ROAD = 1.2;
  var ZIPS = null;
  var TRAVEL = ITEMS.filter(function (it) { return it.travelRate; })[0] || null;

  function zipPoint(zip) { return ZIPS && (ZIPS[zip] || ZIPS[String(zip).slice(0, 3)]); }
  function milesBetween(a, b) {
    var rad = Math.PI / 180;
    var dLat = (b[0] - a[0]) * rad, dLng = (b[1] - a[1]) * rad;
    var h = Math.pow(Math.sin(dLat / 2), 2) + Math.cos(a[0] * rad) * Math.cos(b[0] * rad) * Math.pow(Math.sin(dLng / 2), 2);
    return 3959 * 2 * Math.asin(Math.sqrt(h));
  }
  function eventZip() { return form.elements['Event ZIP'].value.trim(); }
  // { state: 'none' | 'unknown' | 'free' | 'paid' | 'far', miles, dollars }
  function travel() {
    var zip = eventZip();
    if (!TRAVEL || !/^[0-9]{5}$/.test(zip)) return { state: 'none', dollars: 0 };
    var from = zipPoint(TRAVEL.travelFrom), to = zipPoint(zip);
    if (!from || !to) return { state: 'unknown', dollars: 0 };
    var miles = Math.round(milesBetween(from, to) * ROAD);
    if (TRAVEL.travelMax && miles > TRAVEL.travelMax) return { state: 'far', miles: miles, dollars: 0 };
    if (miles <= TRAVEL.travelFree) return { state: 'free', miles: miles, dollars: 0 };
    return { state: 'paid', miles: miles, dollars: Math.round(miles * TRAVEL.travelRate / 100 / 5) * 5 };
  }

  function money(cents) {
    var n = cents / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function track(action, handle) {
    try {
      Shopify.analytics.publish('bc_cta_click', { kind: 'plan', offer: handle || '', page: location.pathname, label: action, link: location.pathname });
    } catch (e) {}
  }

  function say(text) {
    var m = $('[data-msg]');
    m.textContent = text || '';
  }

  // ---------- cart I/O ----------
  function api(path, body) {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + path : '/' + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong');
        return j;
      });
    });
  }
  function load() { return api('cart.js').then(function (c) { cart = c; return c; }); }

  function lineItem(line) {
    var h = line.properties && line.properties._bc;
    return BY[h] || BY[BY_VARIANT[line.variant_id]] || null;
  }
  // Plan lines in menu order (packages, stations, games, extras), not cart order.
  function planLines() {
    return cart.items.filter(function (l) { return lineItem(l); }).sort(function (a, b) {
      return ITEMS.indexOf(lineItem(a)) - ITEMS.indexOf(lineItem(b));
    });
  }
  function stationCount() {
    return planLines().reduce(function (n, l) {
      var it = lineItem(l);
      return n + (it.kind === 'package' || it.kind === 'station' ? it.stations * l.quantity : 0);
    }, 0);
  }
  function hasHosted() {
    return planLines().some(function (l) { return HOSTED[lineItem(l).kind]; });
  }
  function canDiscount(it) {
    return planLines().some(function (l) {
      var o = lineItem(l);
      return HOSTED[o.kind] && o.tags.every(function (t) { return it.tags.indexOf(t) > -1; });
    });
  }
  function discountLines() {
    return planLines().filter(function (l) { return lineItem(l).off; });
  }
  function offTotal() {
    return discountLines().reduce(function (n, l) { return n + lineItem(l).off * 100; }, 0);
  }
  function planTotal() {
    var t = planLines().reduce(function (n, l) { return n + l.original_line_price; }, 0);
    return Math.max(0, t - offTotal());
  }
  function qtyOf(handle) {
    return planLines().reduce(function (n, l) { return n + (lineItem(l).handle === handle ? l.quantity : 0); }, 0);
  }

  function eventLines() {
    return planLines().filter(function (l) { return !NOT_EVENT[lineItem(l).kind]; });
  }
  // Lines use original_line_price: a code from an earlier checkout can stay on
  // the cart and shrink final_line_price, which would trip the minimum.
  // Event value at full price (a 50% hold still counts in full).
  function eventValue() {
    return eventLines().reduce(function (n, l) {
      var it = lineItem(l);
      return n + (it.deposit && l.variant_id === it.deposit ? it.price * l.quantity : l.original_line_price);
    }, 0);
  }

  function variantFor(it) {
    return it.free && it.freeWith && stationCount() >= it.freeWith ? it.free : it.variant;
  }

  function add(it, qty, props) {
    var p = Object.assign({ _bc: it.handle }, props || {});
    if (it.kind !== 'package') p.Item = it.name;
    return api('cart/add.js', { items: [{ id: variantFor(it), quantity: qty, properties: p }] })
      .then(function () { return api('cart/update.js', { attributes: { from: 'plan' } }); });
  }
  function change(line, qty) { return api('cart/change.js', { id: line.key, quantity: qty }); }

  // After any change: free extras flip between paid and free versions.
  function applyRules(_, pass) {
    pass = pass || 1;
    var jobs = [];
    planLines().forEach(function (l) {
      var it = lineItem(l);
      if (!it.free || l.properties && l.properties.Payment) return;
      var want = variantFor(it);
      if (l.variant_id !== want) {
        jobs.push(function () {
          return change(l, 0).then(function () {
            return api('cart/add.js', { items: [{ id: want, quantity: l.quantity, properties: l.properties }] });
          });
        });
      }
    });
    // Fees (kind "fee", e.g. a base visit fee) ride along with any hosted
    // plan and leave when the plan is empty of hosted things.
    var hosted = hasHosted();
    ITEMS.forEach(function (it) {
      if (it.kind !== 'fee' || !it.variant) return;
      var have = planLines().filter(function (l) { return lineItem(l) === it; });
      if (hosted && !have.length) jobs.push(function () { return add(it, 1); });
      if (!hosted) have.forEach(function (l) { jobs.push(function () { return change(l, 0); }); });
    });
    // Money-off items leave when nothing in the plan qualifies any more.
    discountLines().forEach(function (l) {
      if (!canDiscount(lineItem(l))) jobs.push(function () { return change(l, 0); });
    });
    // Travel: one $1 unit per dollar of the distance fee.
    if (TRAVEL && TRAVEL.variant) {
      var trip = planLines().filter(function (l) { return lineItem(l) === TRAVEL; });
      var want = eventLines().length ? travel().dollars : 0;
      var have = trip.reduce(function (n, l) { return n + l.quantity; }, 0);
      if (want !== have) {
        if (trip.length) jobs.push(function () { return change(trip[0], want); });
        else jobs.push(function () { return add(TRAVEL, want); });
      }
    }
    // Booking minimum: top the event up to it, one $1 unit per dollar short.
    ITEMS.forEach(function (it) {
      if (it.kind !== 'minimum' || !it.variant || !it.minimum) return;
      var have = planLines().filter(function (l) { return lineItem(l) === it; });
      var short = eventLines().length ? Math.max(0, Math.ceil((it.minimum * 100 - eventValue()) / it.price)) : 0;
      var now = have.reduce(function (n, l) { return n + l.quantity; }, 0);
      if (short === now) return;
      if (have.length) jobs.push(function () { return change(have[0], short); });
      else jobs.push(function () { return add(it, short); });
    });
    // One change at a time, then look again: a change can re-key other lines,
    // and one rule can trip another (a money-off item leaving empties the
    // event, which clears travel and the minimum).
    if (!jobs.length || pass > 8) return Promise.resolve();
    return jobs[0]().then(load).then(function () { return applyRules(null, pass + 1); });
  }

  function run(fn, okText) {
    if (busy) return Promise.resolve();
    busy = true;
    root.classList.add('is-busy');
    say('');
    return Promise.resolve()
      .then(fn)
      .then(load)
      .then(applyRules)
      .then(load)
      .then(function () { render(); if (okText) say(okText); })
      .catch(function (e) { say(e.message); return load().then(render); })
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }

  // ---------- adding ----------
  function request(handle) {
    var it = BY[handle];
    if (!it || !it.variant) return;
    if (it.needsStation && !hasHosted()) {
      openSheet();
      say('Add a game, a station or a package first, then ' + it.name.toLowerCase() + '.');
      return;
    }
    if (it.off && !canDiscount(it)) {
      openSheet();
      say(it.name + ' is for one-off events. Ask on a call about anything else.');
      return;
    }
    if (qtyOf(handle) >= it.max) {
      openSheet();
      say(it.max === 1 ? it.name + ' is already in your plan.' : 'That\'s the most ' + it.name.toLowerCase() + ' one plan can take. Ask on a call for more.');
      return;
    }
    if (it.pick > 0) return pick(it);
    track('add', handle);
    return run(function () { return add(it, 1); }, it.name + ' added.');
  }

  function pick(it) {
    var dlg = root.querySelector('[data-picker]');
    var list = root.querySelector('[data-pick-list]');
    var stations = ITEMS.filter(function (s) { return s.kind === 'station' && s.variant; });
    var noun = it.tags.indexOf('brands') > -1 ? 'game' : 'station';
    root.querySelector('[data-pick-title]').textContent = it.name + ': pick ' + (it.pick === 1 ? 'your ' + noun : 'your ' + it.pick + ' ' + noun + 's');
    root.querySelector('[data-pick-hint]').textContent = 'Not sure yet? Pick some now and decide the rest on the call.';
    list.innerHTML = '';
    stations.forEach(function (s) {
      var lab = document.createElement('label');
      lab.innerHTML = '<input type="' + (it.pick === 1 ? 'radio' : 'checkbox') + '" name="pick" value="">' +
        (s.image ? '<img src="' + s.image + '" alt="" width="56" height="42" loading="lazy">' : '') + '<span></span>';
      lab.querySelector('input').value = s.name;
      lab.querySelector('span').textContent = s.name;
      list.appendChild(lab);
    });
    list.onchange = function () {
      var on = list.querySelectorAll('input:checked');
      if (on.length > it.pick) on[on.length - 1].checked = false;
    };
    // Handled on submit (not the dialog's close event, which some
    // browsers skip when the tab is in the background).
    dlg.querySelector('form').onsubmit = function (e) {
      e.preventDefault();
      var choice = e.submitter ? e.submitter.value : 'ok';
      dlg.close();
      if (choice === 'cancel') return;
      var chosen = Array.prototype.map.call(list.querySelectorAll('input:checked'), function (i) { return i.value; });
      var left = it.pick - chosen.length;
      var props = { Stations: (chosen.join(', ') || 'We pick on the call') + (chosen.length && left > 0 ? ' + ' + left + ' to pick on the call' : '') };
      if (choice === 'later') props.Stations = 'We pick on the call';
      track('add', it.handle);
      run(function () { return add(it, 1, props); }, it.name + ' added.');
    };
    if (dlg.showModal) dlg.showModal();
    else run(function () { return add(it, 1, { Stations: 'We pick on the call' }); }, it.name + ' added.');
  }

  // ---------- the plan panel ----------
  function render() {
    var lines = planLines();
    var box = $('[data-lines]');
    var total = planTotal();
    box.innerHTML = '';
    if (!lines.length) {
      var p = document.createElement('p');
      p.className = 'bc-plan__empty';
      p.textContent = root.querySelector('.bc-plan__empty') ? root.querySelector('.bc-plan__empty').textContent : 'Nothing yet.';
      box.appendChild(p);
    }
    lines.forEach(function (l) {
      var it = lineItem(l);
      var row = document.createElement('div');
      row.className = 'bc-plan-line';
      var sub = [];
      if (l.properties && l.properties.Stations) sub.push(l.properties.Stations);
      if (l.properties && l.properties.Payment) sub.push(l.properties.Payment);
      if (it.free && l.variant_id === it.free) sub.push('Free with your stations');
      if (it === TRAVEL) sub.push('About ' + travel().miles + ' miles from NYC, ' + money(it.travelRate * 100) + ' per 100 miles');
      else if (it.kind === 'minimum') sub.push('Event plans start at ' + money(it.minimum * 100) + '. Everything above counts toward it.');
      row.innerHTML =
        '<div class="bc-plan-line__name"><strong></strong><small></small></div>' +
        '<div class="bc-plan-line__qty"></div>' +
        '<div class="bc-plan-line__price"></div>' +
        '<button type="button" class="bc-plan-line__remove" aria-label="">Remove</button>';
      row.querySelector('strong').textContent = it.name;
      row.querySelector('small').textContent = sub.join(' · ');
      row.querySelector('.bc-plan-line__price').textContent = it.off ? '−' + money(it.off * 100) : l.original_line_price ? money(l.original_line_price) : 'Free';
      var rm = row.querySelector('.bc-plan-line__remove');
      rm.setAttribute('aria-label', 'Remove ' + it.name);
      rm.onclick = function () { track('remove', it.handle); run(function () { return change(l, 0); }); };
      if (it.kind === 'fee' || it.kind === 'minimum') rm.remove();
      var q = row.querySelector('.bc-plan-line__qty');
      if (it.max > 10) {
        // Big counts (gift bags): type the number instead of tapping +.
        q.innerHTML = '<input type="number" min="0" inputmode="numeric" aria-label=""><span></span>';
        var n = q.querySelector('input');
        n.max = it.max;
        n.value = l.quantity;
        n.setAttribute('aria-label', 'How many ' + it.name.toLowerCase());
        q.querySelector('span').textContent = it.unit ? it.unit + 's' : '';
        n.onchange = function () {
          var v = Math.min(Math.max(0, parseInt(n.value, 10) || 0), it.max);
          run(function () { return change(l, v); });
        };
      } else if (it.max > 1) {
        q.innerHTML = '<button type="button" aria-label="One less">−</button><span></span><button type="button" aria-label="One more">+</button>';
        q.querySelector('span').textContent = l.quantity + (it.unit ? ' ' + it.unit + (l.quantity > 1 ? 's' : '') : '');
        q.firstChild.onclick = function () { run(function () { return change(l, l.quantity - 1); }); };
        q.lastChild.onclick = function () {
          if (qtyOf(it.handle) >= it.max) return say('That\'s the most one plan can take. Ask on a call for more.');
          run(function () { return change(l, l.quantity + 1); });
        };
      }
      if (it.deposit) {
        var held = l.variant_id === it.deposit;
        var t = document.createElement('label');
        t.className = 'bc-plan-line__deposit';
        t.innerHTML = '<input type="checkbox"> Hold with 50% (' + money(it.depositPrice) + ')';
        t.querySelector('input').checked = held;
        t.querySelector('input').onchange = function (e) {
          var props = Object.assign({}, l.properties);
          if (e.target.checked) props.Payment = depositNote(it); else delete props.Payment;
          run(function () {
            return change(l, 0).then(function () {
              return api('cart/add.js', { items: [{ id: e.target.checked ? it.deposit : it.variant, quantity: 1, properties: props }] });
            });
          });
        };
        row.appendChild(t);
      }
      box.appendChild(row);
    });

    var others = cart.items.length - lines.length;
    if (others > 0) {
      var o = document.createElement('p');
      o.className = 'bc-plan__fine';
      o.innerHTML = 'Your cart also has ' + others + ' store item' + (others > 1 ? 's' : '') + '. <a href="/cart">See the cart</a>';
      box.appendChild(o);
    }

    // Held with a deposit: the total is what's due now; say what's left.
    var laterBy = {};
    lines.forEach(function (l) {
      var it = lineItem(l);
      if (!it.deposit || l.variant_id !== it.deposit) return;
      var when = balanceDue(it);
      laterBy[when] = (laterBy[when] || 0) + it.price - l.original_line_price;
    });
    var later = Object.keys(laterBy).length > 0;
    root.querySelector('.bc-plan__total').firstChild.textContent = later ? 'Due now ' : 'Total ';
    Object.keys(laterBy).forEach(function (when) {
      var r = document.createElement('p');
      r.className = 'bc-plan__fine';
      r.textContent = money(laterBy[when]) + ' more is due ' + when + '.';
      box.appendChild(r);
    });

    var count = lines.reduce(function (n, l) {
      var k = lineItem(l).kind;
      return n + (k === 'minimum' || k === 'fee' ? 0 : lineItem(l).unit ? 1 : l.quantity);
    }, 0);

    // Event details only matter when there's an event in the plan.
    var hasEvent = eventLines().length > 0;
    form.hidden = !hasEvent && lines.length > 0;
    var hours = (parseInt(form.getAttribute('data-hours-base'), 10) || 3) + eventLines().reduce(function (n, l) {
      var it = lineItem(l);
      return n + (it.kind === 'addon' && it.unit === 'hour' ? l.quantity : 0);
    }, 0);
    form.elements.Hours.value = hasEvent ? hours : '';
    root.querySelector('[data-hours-text]').textContent = 'Your event runs ' + hours + ' hours. Every game in your plan runs the whole time.';
    var note = root.querySelector('[data-travel-note]');
    if (note) note.textContent = travelNote();
    $('[data-total]').textContent = money(total);
    $('[data-total-bar]').textContent = total ? money(total) : '';
    $('[data-count]').textContent = count ? count + ' thing' + (count > 1 ? 's' : '') : 'Empty';
    root.classList.toggle('has-plan', lines.length > 0);
    $('[data-checkout]').disabled = !lines.length;

    // Card buttons show what's already in the plan.
    $$('[data-add]').forEach(function (b) {
      var it = BY[b.getAttribute('data-add')], n = qtyOf(it.handle);
      b.textContent = !n ? 'Add to my event' : n >= it.max ? '✓ In your plan' : '✓ ' + n + ' in your plan · add more';
      b.classList.toggle('is-added', n > 0);
    });
  }

  function travelNote() {
    var t = travel();
    if (!TRAVEL) return '';
    if (t.state === 'none') return 'Add your ZIP code and we\'ll estimate travel. It\'s free near NYC.';
    if (t.state === 'unknown') return 'We don\'t recognize that ZIP code. Check it, or book a free call.';
    if (t.state === 'free') return 'No travel fee: you\'re in our free area.';
    if (t.state === 'far') return 'That\'s about ' + t.miles + ' miles away. Book a free call and we\'ll work out travel together.';
    return 'About ' + t.miles + ' miles from NYC. Estimated travel: ' + money(t.dollars * 100) + '.';
  }

  // ---------- event details (cart attributes) ----------
  var form = $('[data-details]');
  var saveTimer;
  function details() {
    var out = {};
    Array.prototype.forEach.call(form.elements, function (el) { if (el.name) out[el.name] = el.value.trim(); });
    return out;
  }
  function fillDetails(attrs) {
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.name && attrs[el.name] !== undefined && !el.value) el.value = attrs[el.name];
    });
  }
  form.elements['Event ZIP'].addEventListener('change', function () { run(function () {}); });
  form.addEventListener('input', function () {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () { api('cart/update.js', { attributes: details() }).catch(function () {}); }, 500);
  });
  // A date in the past can't be booked.
  form.elements['Event date'].min = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);

  // ---------- plan as text and as a link ----------
  function planText() {
    var d = details();
    var rows = planLines().map(function (l) {
      var it = lineItem(l), bits = [it.name];
      if (l.quantity > 1) bits.push('× ' + l.quantity);
      if (l.properties && l.properties.Stations) bits.push('(' + l.properties.Stations + ')');
      if (l.properties && l.properties.Payment) bits.push('[' + l.properties.Payment + ']');
      bits.push(it.off ? '-' + money(it.off * 100) : l.original_line_price ? money(l.original_line_price) : 'free');
      return '- ' + bits.join(' ');
    });
    var total = planTotal();
    return ['Event plan from budcade.com/plan', ''].concat(rows, ['', 'Total: ' + money(total), ''],
      Object.keys(d).filter(function (k) { return d[k]; }).map(function (k) { return k + ': ' + d[k]; }),
      ['', 'Plan link: ' + shareLink()]).join('\n');
  }
  function shareLink() {
    var data = {
      // Fees and the minimum rebuild themselves from the rules.
      i: planLines().filter(function (l) { var k = lineItem(l).kind; return k !== 'fee' && k !== 'minimum'; }).map(function (l) {
        var it = lineItem(l), row = [it.handle, l.quantity];
        if (l.properties && l.properties.Stations) row[2] = l.properties.Stations;
        if (it.deposit && l.variant_id === it.deposit) row[3] = 1;
        return row;
      }),
      d: details()
    };
    var json = JSON.stringify(data);
    var b64 = btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return location.origin + location.pathname + '?plan=' + b64;
  }
  function readShared(code) {
    try {
      var b64 = code.replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(decodeURIComponent(escape(atob(b64))));
    } catch (e) { return null; }
  }
  function restore(data) {
    // Replace whatever plan this browser had with the shared one.
    return planLines().reduce(function (p, l) { return p.then(function () { return change(l, 0); }); }, Promise.resolve())
      .then(function () {
        var items = (data.i || []).map(function (row) {
          var it = BY[row[0]];
          if (!it || !it.variant) return null;
          var props = { _bc: it.handle };
          if (it.kind !== 'package') props.Item = it.name;
          if (row[2]) props.Stations = String(row[2]);
          if (row[3] && it.deposit) props.Payment = depositNote(it);
          return { id: row[3] && it.deposit ? it.deposit : it.variant, quantity: Math.min(Math.max(1, row[1] | 0), it.max), properties: props };
        }).filter(Boolean);
        return items.length ? api('cart/add.js', { items: items }) : null;
      })
      .then(function () {
        var d = data.d || {};
        d.from = 'plan';
        return api('cart/update.js', { attributes: d });
      })
      .then(function () {
        Array.prototype.forEach.call(form.elements, function (el) { if (el.name) el.value = ''; });
        fillDetails(data.d || {});
      });
  }

  // ---------- sheet (phones) ----------
  var sheet = $('[data-sheet]');
  var bar = $('[data-open]');
  function openSheet() {
    root.classList.add('is-open');
    bar.setAttribute('aria-expanded', 'true');
  }
  function closeSheet() {
    root.classList.remove('is-open');
    bar.setAttribute('aria-expanded', 'false');
  }
  bar.addEventListener('click', function () { root.classList.contains('is-open') ? closeSheet() : openSheet(); });
  $('[data-close]').addEventListener('click', closeSheet);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

  // ---------- buttons ----------
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (b) request(b.getAttribute('data-add'));
  });

  $('[data-checkout]').addEventListener('click', function () {
    if (eventLines().length && !form.elements['Event date'].value) {
      openSheet();
      say('Add your date first so we can hold it for you.');
      form.elements['Event date'].focus();
      return;
    }
    if (TRAVEL && eventLines().length) {
      var trip = travel();
      if (trip.state === 'none' || trip.state === 'unknown') {
        openSheet();
        say('Add your event ZIP code so we can estimate travel.');
        form.elements['Event ZIP'].focus();
        return;
      }
      if (trip.state === 'far') {
        openSheet();
        say('That\'s a long trip. Book a free call and we\'ll work out travel together.');
        return;
      }
    }
    track('checkout');
    clearTimeout(saveTimer);
    api('cart/update.js', { attributes: details() }).then(function () {
      var codes = discountLines().map(function (l) { return lineItem(l).code; }).filter(Boolean);
      location.href = '/checkout?discount=' + encodeURIComponent(codes.join(','));
    });
  });

  $('[data-share]').addEventListener('click', function () {
    var link = shareLink();
    track('share');
    var done = function () { say('Link copied. Open it on any device to pick up this plan.'); };
    if (navigator.clipboard) navigator.clipboard.writeText(link).then(done, function () { window.prompt('Copy this link:', link); });
    else window.prompt('Copy this link:', link);
  });

  $('[data-clear]').addEventListener('click', function () {
    if (!planLines().length || !window.confirm('Remove everything from your plan?')) return;
    track('clear');
    run(function () {
      return planLines().reduce(function (p, l) { return p.then(function () { return change(l, 0); }); }, Promise.resolve());
    }, 'Your plan is empty.');
  });

  var sendForm = root.querySelector('[data-send]');
  $('[data-send-open]').addEventListener('click', function () {
    if (!planLines().length) return say('Add something to your plan first.');
    var f = sendForm.querySelector('[data-send-fields]');
    f.hidden = false;
    f.querySelector('input').focus();
  });
  sendForm.addEventListener('submit', function () {
    sendForm.querySelector('[data-send-body]').value = planText();
    track('send');
  });

  // The free-call link carries the page tag like every other call button.
  var call = $('[data-call-link]');
  if (call.href.indexOf('budcade.com/book') > -1 && call.href.indexOf('?') < 0) {
    call.href += '?utm_source=site&utm_medium=button&utm_content=plan';
  }

  // ---------- start ----------
  var params = new URLSearchParams(location.search);
  var zipsReady = TRAVEL ? fetch(root.getAttribute('data-zips')).then(function (r) { return r.json(); }).then(function (z) { ZIPS = z; }).catch(function () {}) : Promise.resolve();
  zipsReady.then(load).then(function () {
    fillDetails(cart.attributes || {});
    render();
    if (root.querySelector('[data-sent]')) openSheet();
    var shared = params.get('plan') && readShared(params.get('plan'));
    if (shared) {
      return run(function () { return restore(shared); }, 'Here\'s the shared plan.').then(function () {
        openSheet();
        history.replaceState(null, '', location.pathname);
      });
    }
    var adding = params.get('add');
    if (adding && BY[adding]) {
      history.replaceState(null, '', location.pathname);
      var card = document.getElementById('item-' + adding);
      if (card) card.scrollIntoView({ block: 'center' });
      if (!qtyOf(adding)) request(adding);
    }
  });
})();
